export default {
    isCorporate: function(user) {
        return ['corporate-admin', 'corporate-user'].includes(user.roleName);
    },

    initControllTimer: function(time) {
        const now = new Date();
        const startTime = Date.create(time);

        const hoursDiff = now.hoursSince(startTime);
        let minutesDiff = now.minutesSince(startTime);
        let secondsDiff = now.secondsSince(startTime);
        secondsDiff -= minutesDiff * 60;
        minutesDiff -= hoursDiff * 60;

        let timeParts;
        if (hoursDiff > 0) {
            timeParts = [hoursDiff, minutesDiff, secondsDiff];
        } else {
            timeParts = [minutesDiff, secondsDiff];
        }

        // Need math abs to work with negative time
        return timeParts.map((it) => Math.abs(it).pad(2)).join(':');
    },

    sortAddresses: function(addresses, noAddressString) {
        const sortedAddresses = addresses.slice()
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .reduce((result, it) => {
                if (it.place && it.place.street) {
                    result.push(it.place.street + ' ' + (it.place.houseNumber || ''));
                }
                return result;
            }, [])
            .join(', ');
        return (sortedAddresses.length) ? sortedAddresses : noAddressString;
    }
};

export const downloadBlob = (data, file) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', file);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const demical = (value) => {
    if (!value) {
        return true;
    }

    return Number(value) == value;
};

export const copyToClipboard = (text, useReg = false) => {
    if (useReg) {
        const reg = text.match(/^\+\d{2}(\d{10})$/);

        text = reg && reg[1] || text;
    }

    const dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.setAttribute('id', 'Cheivoh8');
    document.getElementById('Cheivoh8').value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
};

export function vLength(min, max = min) {
    return function(value) {
        return !value || !value.length || value.length <= max && value.length >= min;
    };
}

export const getFormData = (object) => Object.keys(object).reduce((formData, key) => {
    if (object[key] !== undefined && object[key] !== null) {
        formData.append(key, object[key]);
    }
    return formData;
}, new FormData());

export const parseJSON = (data) => {
   try {
       return JSON.parse(data);
   } catch (e) {
       return null;
   }
};

export const normalizedPhone = phoneNumber => {
    if (!phoneNumber) {
        return '';
    }

    const hasPrefix = new RegExp(/^\+380/).test(phoneNumber);

    if (hasPrefix) {
        phoneNumber = phoneNumber.replace('+380', '');
        return phoneNumber;
    }

    return `+380${phoneNumber}`;
};
